import { render } from "./Cocktail.vue?vue&type=template&id=06347c6a&scoped=true"
import script from "./Cocktail.vue?vue&type=script&lang=js"
export * from "./Cocktail.vue?vue&type=script&lang=js"

import "./Cocktail.vue?vue&type=style&index=0&id=06347c6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06347c6a"]])

export default __exports__